import { render, staticRenderFns } from "./EditUserReportPreferences.vue?vue&type=template&id=a2da5da2&scoped=true&"
import script from "./EditUserReportPreferences.vue?vue&type=script&lang=js&"
export * from "./EditUserReportPreferences.vue?vue&type=script&lang=js&"
import style0 from "./EditUserReportPreferences.vue?vue&type=style&index=0&id=a2da5da2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2da5da2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2da5da2')) {
      api.createRecord('a2da5da2', component.options)
    } else {
      api.reload('a2da5da2', component.options)
    }
    module.hot.accept("./EditUserReportPreferences.vue?vue&type=template&id=a2da5da2&scoped=true&", function () {
      api.rerender('a2da5da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EditUserReportPreferences.vue"
export default component.exports